<template>
  <v-layout
    justify-center
    wrap
  >
    <v-flex
      xs12
      md7
      lg7
    >
      <h2 v-if="!moduleStaking">
        {{ $t('modules.stakingNewToken') }}
      </h2>
      <h2 v-else>
        {{ $t('modules.stakingEditToken') }}
      </h2>
      <v-card class="pt-7 pl-5 pr-5">
        <v-form>
          <v-layout wrap>
            <v-flex
              xs12
              md12
            >
              <v-text-field
                v-model.trim="form.symbol"
                :counter="20"
                :error-messages="SymbolErrors"
                :label="$t('modules.stakingSymbol')+ '*'"
                required
                @input="$v.form.symbol.$touch()"
                @blur="$v.form.symbol.$touch()"
              />
            </v-flex>
            <v-flex
              xs12
              md12
            >
              <v-text-field
                v-model.trim="form.token_contract_address"
                :error-messages="TokenContractErrors"
                :label="$t('modules.tokenContract')+ '*'"
                required
                @input="$v.form.token_contract_address.$touch()"
                @blur="$v.form.token_contract_address.$touch()"
              />
            </v-flex>
            <v-flex
              xs12
              md12
            >
              <v-text-field
                v-model.trim="form.staking_contract_address"
                :error-messages="StakingContractErrors"
                :label="$t('modules.stakingContract')"
                @input="$v.form.staking_contract_address.$touch()"
                @blur="$v.form.staking_contract_address.$touch()"
              />
            </v-flex>
            <v-flex
              xs12
              md4
            >
              <v-select
                v-model.trim="form.network"
                :items="moduleData.public_config.networks"
                :item-text="'name'"
                :item-value="'module'"
                :error-messages="NetworkErrors"
                :label="$t('modules.stakingNetwork')+'*'"
                required
                @change="$v.form.network.$touch()"
              />
            </v-flex>
            <v-flex
              xs12
              md8
            >
              <v-text-field
                v-model.trim="form.network_api_key"
                :error-messages="NetworkApiKeyErrors"
                :label="$t('modules.stakingNetworkApiKey')+ '*'"
                required
                @input="$v.form.network_api_key.$touch()"
                @blur="$v.form.network_api_key.$touch()"
              />
            </v-flex>
            <v-flex
              xs12
              md4
            >
              <v-select
                v-model.trim="form.token_price_provider"
                :items="moduleData.public_config.token_price_providers"
                :item-text="'name'"
                :item-value="'module'"
                :error-messages="ExchangeRateProviderErrors"
                :label="$t('modules.stakingExchangeRateProvider')+'*'"
                required
                @change="$v.form.token_price_provider.$touch()"
              />
            </v-flex>
            <v-flex
              xs12
              md8
            >
              <v-text-field
                v-model.trim="form.price_provider_token_id"
                :error-messages="ProviderTokenIdErrors"
                :label="$t('modules.stakingPriceProviderTokenId')"
                required
                @input="$v.form.price_provider_token_id.$touch()"
                @blur="$v.form.price_provider_token_id.$touch()"
              />
            </v-flex>
            <v-flex md12>
              <v-checkbox
                v-model="form.use_staking"
                color="primary"
              >
                <template
                  v-slot:label
                >
                  <small>
                    {{ $t('modules.stakingUseToken') }}
                  </small>
                </template>
              </v-checkbox>
            </v-flex>
            <v-flex
              v-show="showExtraFields"
              xs12
              md7
            >
              <v-text-field
                v-model.trim.number="form.staked_tokens_in_usdt"
                :error-messages="StakedTokensErrors"
                :label="$t('modules.stakingTokenforFreeSubscription')"
                suffix="USDT"
                @input="$v.form.staked_tokens_in_usdt.$touch()"
                @blur="$v.form.staked_tokens_in_usdt.$touch()"
                @keypress="onlyForCurrency($event, form.staked_tokens_in_usdt)"
              />
            </v-flex>
            <v-flex
              v-show="showExtraFields"
              md12
            >
              <v-checkbox
                v-model="form.based_on_deposit"
                color="primary"
              >
                <template
                  v-slot:label
                >
                  <small>
                    {{ $t('modules.stakingBasedOnDeposit') }}
                  </small>
                </template>
              </v-checkbox>
            </v-flex>
            <v-flex
              v-show="showExtraFields && form.based_on_deposit"
              xs12
              md7
            >
              <v-text-field
                v-model.trim.number="form.trading_deposit_percentage"
                :label="$t('modules.stakingDepositPercent')"
                type="number"
                suffix="%"
                :error-messages="DepositPercetageErrors"
                @input="$v.form.trading_deposit_percentage.$touch()"
                @blur="$v.form.trading_deposit_percentage.$touch()"
              >
                >
                <template v-slot:append>
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <v-icon v-on="on">
                        mdi-information-outline
                      </v-icon>
                    </template>
                    {{ $t('modules.stakingDepositPercentHint') }} 
                  </v-tooltip>
                </template>
              </v-text-field>
            </v-flex>
            <v-flex
              v-show="showExtraFields"
              md12
            >
              <v-checkbox
                v-model="form.pause_if_not_enough_tokens"
                color="primary"
              >
                <template
                  v-slot:label
                >
                  <small>
                    {{ $t('modules.stakingPauseService') }}
                  </small>
                </template>
              </v-checkbox>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex
              xs12
              md12
            >
              <v-btn
                fab
                outlined
                small
                text
                @click="$emit('changeEditMode', false)"
              >
                <v-icon>mdi-arrow-left</v-icon>
              </v-btn>
              <v-btn
                color="primary"
                style="float:right"
                :disabled="loading"
                :loading="loading"
                @click="save()"
              >
                {{ $t('globals.saveButton') }}
              </v-btn>
            </v-flex>
          </v-layout>
        </v-form>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import UPDATE_STAKING_MUTATION from "@/graphql/mutations/modules/StakingUpdate.gql";
import { validationMixin } from "vuelidate";
import {
  required,
  minLength,
  maxLength,
  between
} from "vuelidate/lib/validators";

const WAValidator = require('multicoin-address-validator');

const validateWallet = (address) => {
  if (!address) return true
  return WAValidator.validate(address, 'ETH')
}

export default {
  name: "ModuleStakingEditForm",
  mixins: [validationMixin],
  props: {
    moduleStaking: {
      type: Object,
      default: null
    },
    whitelabelUuid: {
      type: String,
      default: null
    },
    moduleData: {
      type: Object,
      default: null
    }
  },
  data: () => ({
    loading: false,
    showExtraFields: false,
    form: {
      symbol: null,
			token_contract_address: null,
      staking_contract_address: null,
			network: null,
      network_api_key: null,
			token_price_provider: null,
      price_provider_token_id: null,
			use_staking: false,
			based_on_deposit: false,
			pause_if_not_enough_tokens: false,
			staked_tokens_in_usdt: 0,
			trading_deposit_percentage: 0
    }
  }),
  computed: {
    rules() {
      return {
        symbol: {
          required,
          minLength: minLength(2),
          maxLength: maxLength(20),
        },
        token_contract_address: {
          required,
          validateWallet
        },
        staking_contract_address: {
          validateWallet
        },
        network: {
          required,
        },
        token_price_provider: {
          required,
        },
        network_api_key: {
          required,
          maxLength: maxLength(2000),
        },
        price_provider_token_id: {
          maxLength: maxLength(2000),
        },
        staked_tokens_in_usdt: {
          required,
          between: between(0, 999999999),
        },
        trading_deposit_percentage: {
          required,
          between: between(0, 100),
        },
      }
    },
    SymbolErrors(value) {
      const errors = [];
      if (!this.$v.form.symbol.$dirty) return errors;
      !this.$v.form.symbol.required && errors.push(this.$t("profile.reqField"));
      !this.$v.form.symbol.minLength &&
        errors.push(this.$t("whitelabel.minError", {char: this.$v.form.symbol.$params.minLength.min}));
      !this.$v.form.symbol.maxLength &&
        errors.push(this.$t("whitelabel.maxError", {char: this.$v.form.symbol.$params.maxLength.max}));
      return errors;
    },
    TokenContractErrors() {
      const errors = [];
      if (!this.$v.form.token_contract_address.$dirty) return errors;
      !this.$v.form.token_contract_address.required && errors.push(this.$t("profile.reqField"));
      !this.$v.form.token_contract_address.validateWallet &&
        errors.push(this.$t("modules.stakingContractNotValid"));
      return errors;
    },
    StakingContractErrors() {
      const errors = [];
      if (!this.$v.form.staking_contract_address.$dirty) return errors;
      !this.$v.form.staking_contract_address.validateWallet &&
        errors.push(this.$t("modules.stakingContractNotValid"));
      return errors;
    },
    NetworkErrors(value) {
      const errors = [];
      if (!this.$v.form.network.$dirty) return errors;
      !this.$v.form.network.required && errors.push(this.$t("profile.reqField"));
      return errors;
    },
    ExchangeRateProviderErrors(value) {
      const errors = [];
      if (!this.$v.form.token_price_provider.$dirty) return errors;
      !this.$v.form.token_price_provider.required && errors.push(this.$t("profile.reqField"));
      return errors;
    },
    NetworkApiKeyErrors(value) {
      const errors = [];
      if (!this.$v.form.network_api_key.$dirty) return errors;
      !this.$v.form.network_api_key.required && errors.push(this.$t("profile.reqField"));
      !this.$v.form.network_api_key.maxLength &&
        errors.push(this.$t("whitelabel.maxError", {char: this.$v.form.network_api_key.$params.maxLength.max}));
      return errors;
    },
    ProviderTokenIdErrors(value) {
      const errors = [];
      if (!this.$v.form.price_provider_token_id.$dirty) return errors;
      !this.$v.form.price_provider_token_id.maxLength &&
        errors.push(this.$t("whitelabel.maxError", {char: this.$v.form.price_provider_token_id.$params.maxLength.max}));
      return errors;
    },
    StakedTokensErrors() {
      const errors = [];
      if (!this.$v.form.staked_tokens_in_usdt.$dirty) return errors;
      !this.$v.form.staked_tokens_in_usdt.required && errors.push(this.$t("profile.reqField"));
      !this.$v.form.staked_tokens_in_usdt.between &&
        errors.push(this.$t("whitelabel.betweenError", {
          char: this.$v.form.staked_tokens_in_usdt.$params.between.min,
          char2: this.$v.form.staked_tokens_in_usdt.$params.between.max
        }));
      return errors;
    },  
    DepositPercetageErrors() {
      const errors = [];
      if (!this.$v.form.trading_deposit_percentage.$dirty) return errors;
      !this.$v.form.trading_deposit_percentage.required && errors.push(this.$t("profile.reqField"));
      !this.$v.form.trading_deposit_percentage.between &&
        errors.push(this.$t("whitelabel.betweenError", {
          char: this.$v.form.trading_deposit_percentage.$params.between.min,
          char2: this.$v.form.trading_deposit_percentage.$params.between.max
        }));
      return errors;
    }
  },
  watch: {
    form: {
      handler(val){
        if (!val.use_staking) {
          this.showExtraFields = false
          this.form.based_on_deposit = false
          this.form.pause_if_not_enough_tokens = false
          this.form.staked_tokens_in_usdt = 0
          this.form.trading_deposit_percentage = 0
        } else {
          this.showExtraFields = true
        }
      },
      deep: true
    }
  },
  mounted() {
    const form = JSON.parse(JSON.stringify(this.moduleStaking))
    if (form) {
      this.form = form
    }
  },
  validations() {
    return {
      form: this.rules
    };
  },
  methods: {  
    save() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return
      }
      this.loading = true; 
      this.form.whitelabel_uuid = this.whitelabelUuid
      this.$apollo
        .mutate({
          mutation: UPDATE_STAKING_MUTATION,
          variables: this.form
        })
        .then(data => {
          this.$parent.$apollo.queries.moduleStaking.refetch();
          this.$emit('changeEditMode', false)
        })
        .catch(error => {
          this.loading = false;
          if (error.graphQLErrors[0].extensions.category == 'authorization' && error.graphQLErrors[0].message === "This action is unauthorized.") {
            this.$store.commit("app/setShowPermission");
            return;
          }
          this.errorHandler(error);
        });
    }
  }
}
</script>

<style lang="scss">

</style>
